import(/* webpackMode: "eager" */ "/home/runner/work/customer-frontend/customer-frontend/src/app/(loginGuarded)/(orderGuarded)/layout.tsx");
